import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useReveal = () => {
  const location = useLocation();

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    const applyReveal = () => {
      const revealElements = document.querySelectorAll('[data-sw-reveal]');
      revealElements.forEach(el => observer.observe(el));
    };

    applyReveal();

    // Also handle dynamic content (like Firebase data)
    const mutationObserver = new MutationObserver(() => {
      applyReveal();
    });

    mutationObserver.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      mutationObserver.disconnect();
    };
  }, [location.pathname]);
};
